(async () => {
  if (!customElements.get('shop-drawer')) {
    class VariantStoreAvailability extends HTMLElement {
      constructor() {
        super();
        this.token = this.dataset.token;
        this.handle = this.dataset.handle;

        this.locations = this.querySelector('shop-locations');
        this.variantsWrapper = this.querySelector('variants-product fieldset');

        if (this.variantsWrapper) {
          this.variantsWrapper
            .querySelectorAll('input')
            .forEach((variant) =>
              variant.addEventListener(
                'click',
                this.linkClick.bind(this, event, variant, this.handle, this.token)
              )
            );
        }
      }

      linkClick(event, variant, handle, token) {
        this.variantsWrapper
          .querySelectorAll("input[type='radio']:checked")
          .forEach((activeVariant) => (activeVariant.checked = false));
        if (variant.checked == 0) {
          variant.checked = true;
          this.updateStores(variant, handle, token);
        }
      }

      getVariantsData() {
        this.variantsData =
          this.variantsData ||
          JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantsData;
      }

      getLocationsData() {
        this.locationsData =
          this.locationsData ||
          JSON.parse(this.querySelector('[type="locations/json"]').textContent);
        return this.locationsData;
      }
      updateStores(variant, handle, token) {
        const activeVariantValue = variant.value;
        const storesWrapper = this.querySelector('shop-locations');
        const stores = storesWrapper.querySelectorAll('[data-location]');
        console.log('stores', stores);

        const productQuery = () =>
          `
          query {
            product(handle: "` +
          handle +
          `") {
              title
              totalInventory
              variants(first: 10) {
                nodes {
                  title
                  availableForSale
                  quantityAvailable
                  storeAvailability(first: 10) {
                    nodes {
                      available
                      location {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        `;

        console.log('productQuery', productQuery());

        const STOREFRONT_ACCESS_TOKEN = token;
        console.log('STOREFRONT_ACCESS_TOKEN:', STOREFRONT_ACCESS_TOKEN);

        const GRAPHQL_URL = `https://` + location.host + `/api/2023-04/graphql.json`;
        console.log('GRAPHQL_URL:', GRAPHQL_URL);

        const GRAPHQL_BODY = () => {
          return {
            async: true,
            crossDomain: true,
            method: 'POST',
            headers: {
              'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
              'Content-Type': 'application/graphql',
            },
            body: productQuery(),
          };
        };

        fetch(GRAPHQL_URL, GRAPHQL_BODY())
          .then((res) => res.json())
          .then((product) => {
            this.variants = product.data.product.variants;
            var variantsArr = this.variants.nodes;

            // Loop over variants to get store locations
            for (var i = 0; i < variantsArr.length; i++) {
              if (variantsArr[i].title == activeVariantValue) {
                const storeArr = variantsArr[i].storeAvailability.nodes;

                // Loop over variant stores to check availability
                for (var a = 0; a < storeArr.length; a++) {
                  var locationIdStr = storeArr[a].location.id.split('/');
                  const locationId = locationIdStr[locationIdStr.length - 1];
                  const locationAvailable = storeArr[a].available;

                  // update stores info
                  storesWrapper.querySelectorAll('[data-location]').forEach((store) => {
                    const storeId = store.dataset.location;
                    if (storeId == locationId) {
                      // get all elements to update
                      var storeAvailableBtn = store.querySelector('[data-location-button]');
                      var storeAvailableBtnTxt = store.querySelector(
                        '[data-button-available-text]'
                      );
                      var storeUnavailableBtnTxt = store.querySelector(
                        '[data-button-unavailable-text]'
                      );
                      var BtnAvailableIcon = store.querySelector('.icon--checkmark');
                      var BtnUnavailableIcon = store.querySelector('.icon--cross');

                      var storeAvailableTxt = store.querySelector('[data-available-txt]');
                      var storeUnavailableTxt = store.querySelector('[data-unavailable-txt]');

                      // update elements based on store  availability
                      if (locationAvailable) {
                        storeAvailableBtn.classList.remove('disabled');
                        BtnAvailableIcon.classList.remove('hidden');
                        BtnUnavailableIcon.classList.add('hidden');
                        storeAvailableBtnTxt.classList.remove('hidden');
                        storeUnavailableBtnTxt.classList.add('hidden');
                        storeAvailableTxt.classList.remove('hidden');
                        storeUnavailableTxt.classList.add('hidden');
                      } else {
                        storeAvailableBtn.classList.add('disabled');
                        BtnAvailableIcon.classList.add('hidden');
                        BtnUnavailableIcon.classList.remove('hidden');
                        storeAvailableBtnTxt.classList.add('hidden');
                        storeUnavailableBtnTxt.classList.remove('hidden');
                        storeAvailableTxt.classList.add('hidden');
                        storeUnavailableTxt.classList.remove('hidden');
                      }
                    }
                  });
                }
              }
            }
          });
      }
    }
    customElements.define('shop-drawer', VariantStoreAvailability);
  }
})();
